import React from 'react';

interface DragPreviewProps {
  dragSelection: {
    dayIndex: number;
    startTimeIndex: number;
    endTimeIndex: number;
  };
}

const SLOT_HEIGHT = 24; // 24px per 30-min slot

const DragPreview: React.FC<DragPreviewProps> = ({ dragSelection }) => {
  const { startTimeIndex, endTimeIndex } = dragSelection;
  const minSlot = Math.min(startTimeIndex, endTimeIndex);
  const maxSlot = Math.max(startTimeIndex, endTimeIndex);

  const topPosition = minSlot * SLOT_HEIGHT;
  const height = (maxSlot - minSlot + 1) * SLOT_HEIGHT;

  // Convert slot index to time string (AM/PM, midnight-to-midnight)
  const formatTime = (slotIndex: number) => {
    const hour = Math.floor(slotIndex / 2);
    const minute = (slotIndex % 2) * 30;
    const period = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    return `${displayHour}:${minute.toString().padStart(2, '0')} ${period}`;
  };

  return (
    <div
      className="absolute left-1 right-1 bg-clinic-primary/30 border-2 border-clinic-primary rounded opacity-80 pointer-events-none z-30 flex items-center justify-center"
      style={{
        top: `${topPosition}px`,
        height: `${height}px`
      }}
    >
      <div className="text-xs font-medium text-clinic-primary-dark bg-white bg-opacity-90 px-2 py-1 rounded shadow-sm">
        {formatTime(minSlot)} - {formatTime(maxSlot + 1)}
      </div>
    </div>
  );
};

export default React.memo(DragPreview);